import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
      <div>
  <div className="undermenu">
    <div className="container trongsuot">
      <div className="row logo-image">
        <img src="images/logo-drive.png" alt />
      </div>
      <div className="row title-intro">
        <h1>A safe place for all your files</h1>
      </div>
      <div className="row personal-business no-gutters">
        <div className="col-md-6">
          <div className="trai">
            <h2>Personal</h2>
            <p>Store, share, and access your files from any device. Your first 15 GB of storage are free.</p>
            <div className="nut">
              <button type="button" className="btn btn-info">Go to Google Drive</button>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="phai">
            <h2>Business</h2>
            <p>With Drive Enterprise, businesses only pay for the storage employees use. It comes with Google Docs, Sheets, and Slides — and works seamlessly with Microsoft Office.</p>
            <div className="nut"><button type="button" className="btn btn-info">Learn more</button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="storeanyfile">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="trai">
            <img className="img-fluid" src="images/icon.jpg" alt />
          </div>
        </div>
        <div className="col-md-6">
          <div className="phai text-center text-md-left">
            <h1>Store any file</h1>
            <p>Keep photos, stories, designs, drawings, recordings, videos, and more. Your first 15 GB of storage are free with a Google Account.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="backgroundimage1">
  </div>
  <div className="seeYourStuffAnywhere">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6 ">
          <div className="trai text-center text-md-left">
            <h1>See your stuff anywhere</h1>
            <p>Your files in Drive can be reached from any smartphone, tablet, or computer. So wherever you go, your files follow.</p>
          </div>
        </div>
        <div className="col-md-6 text-center text-md-left">
          <div className="phai" style={{width: '100%'}}>
            {/* để cho image bên trong nó mới canh giữa được */}
            <img src="images/files-anywhere.jpg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="backgroundimage2">
  </div>
  <div className="shareFilesAndFolders">
    <div className="container">
      <img className="img-fluid" src="images/share.jpg" alt />
      <h1>Share files and folder</h1>
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <p>You can quickly invite others to view, download, and collaborate on all the files you want–no email attachment needed.</p>
        </div>
      </div>
    </div>
  </div>
  <div className="backgroundimage3">
  </div>
  <div className="getStartedWithDriveForFree">
    <div className="aligncenter">
      <img src="images/logo-drive.png" alt />
      <h1>Get started with Drive for free</h1>
      <button type="button" className="btn btn-primary">Go to Google Drive</button>
      <br />
      <a href>Need more than 15 GB? Upgrade to Google One <i className="fas fa-angle-right" /></a>
    </div>
  </div>
  <div className="footer">
    <div className="container">
      <div className="row hang1">
        Follow: <i className="fab fa-twitter-square" /> <i className="fab fa-blogger" />
      </div>
      <div className="row hang2">
        <div className="col-4 col-md-2 ">
          <div className="footer_title">
            About Drive
          </div>
          <div className="footer_link">
            <a href>Meet Google Drive</a>
            <a href>Using Drive</a>
            <a href>Get Started with Drive</a>
          </div>
        </div>
        <div className="col-4 col-md-3 ">
          <div className="footer_title">
            Storage plans and pricing
          </div>
          <div className="footer_link">
            <a href>Get more storage</a>
            <a href>Pricing FAQs</a>
            <a href>Free up space</a>
          </div>
        </div>
        <div className="col-4 col-md-2 ">
          <div className="footer_title">
            Downloads
          </div>
          <div className="footer_link">
            <a href>Drive for Mac/PC</a>
            <a href>Drive for Android</a>
            <a href>Drive for iOS</a>
          </div>
        </div>
        <div className="col-4 col-md-2 ">
          <div className="footer_title">
            Support
          </div>
          <div className="footer_link">
            <a href>Help Center for Drive</a>
            <a href>Google Drive Help Forum</a>
            <a href>Contact Us</a>
          </div>
        </div>
        <div className="col-4 col-md-3 ">
          <div className="footer_title">
            Related Solutions
          </div>
          <div className="footer_link">
            <a href>Google Docs</a>
            <a href>Google Sheets</a>
            <a href>Google Slides</a>
            <a href>Google Forms</a>
            <a href>Google Drive for Work</a>
            <a href>Google Cloud Platform</a>
            <a href>Google Apps for Education</a>
            <a href>Google Apps for Government</a>
            <a href>Google Business Solutions</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="aboutgoogle">
    <div className="container">
      <div className="row">
        <div className="col-md-6 trai">
          <a href>Google</a>
          <a href>About Google</a>
          <a href>Privacy</a>
          <a href>Terms</a>
        </div>
        <div className="col-md-6 phai d-flex align-items-center justify-content-md-end">
          {/* md mới xếp End, còn size nhỏ là xếp Start */}
          <i className="fas fa-globe" />
          <div className="form-group">
            <select className="form-control" id="language_selection">
              <option value="/intl/af_ALL/drive/">
                Afrikaans
              </option>
              <option value="/intl/uk_ALL/drive/">
                українська
              </option>
              <option value="/intl/ur_ALL/drive/">
                اردو
              </option>
              <option value="/intl/vi_ALL/drive/">
                Tiếng Việt
              </option>
              <option value="/intl/zh-CN_ALL/drive/">
                中文 (简体, 中国)
              </option>
              <option value="/intl/zh-HK_ALL/drive/">
                中文 (繁體字, 中國香港特別行政區)
              </option>
              <option value="/intl/zh-TW_ALL/drive/">
                中文 (繁體, 台灣)
              </option>
              <option value="/intl/zu_ALL/drive/">
                isiZulu
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    );
  }
}

export default Home;